import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "d-inline-block p-1" }
const _hoisted_3 = { class: "d-inline-block p-1" }
const _hoisted_4 = {
  key: 0,
  class: "p-2"
}
const _hoisted_5 = {
  key: 1,
  class: "p-2"
}

import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElMessage, ElMessageBox } from 'element-plus';
    import { useStore } from 'vuex';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PlacesView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const data = ref<Array<any>>()

    const getPlaces = async () => {
        const res = await Api.get('admin/ads')
        if (res.status == 200) {
            data.value = res.data.ads
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
    }
    onBeforeMount(async () => {
        await getPlaces()
        loading.value = false
    })

    const remove = async (_data: any) => {
        _data.row.loading = true
        const res = await Api.delete('admin/ads/' + _data.row.id)
        if (![200].includes(res.status)) {
            ElMessage.error({message: 'Ocorreu um erro ao eliminar ' + _data.row.name})
        } else {
            ElMessage.success({message: 'Atualizado ' + _data.row.name})
            if (data.value) {
                console.log(res.data)
                data.value[_data.$index] = res.data.ad
            }
            // data.value?.splice(_data.$index, 1)
        }
        _data.row.loading = false
        console.log(_data.$index)
    }

    const store = useStore()
    store.watch((s, g) => g.openModal, async (n, o) => {
        o == 3 && await getPlaces()
    })

    const featured = async (row: any) => {
        row.loading = true
        const res = await Api.put(`admin/featured/ad/${row.id}`, {})
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
        } else {
            ElMessage.success({message: row.name + ' Actualizado com sucesso'})
            row.featured = !row.featured
        }
        row.loading = false
    }

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Lugares de propagandas" }, {
      default: _withCtx(() => [
        _createVNode(PersonalTable, {
          loading: loading.value,
          height: 450,
          showRows: 10,
          cols: [
                {label: 'Cod', prop: 'id'},
                {label: 'Nome', prop: 'name'},
            ],
          data: data.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Adicionado por",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.user.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Adicionado em",
              "class-name": "auto",
              "min-width": 100
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(new Date(data.row.created_at).toLocaleString()), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Activo",
              "class-name": "auto",
              "min-width": 60
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.active ? "Sim":"Não"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Localização",
              "class-name": "auto",
              "min-width": 100
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.area.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Acções",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createElementVNode("span", _hoisted_2, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    tag: "router-link",
                    to: '/places/' + data.row.id,
                    icon: "View",
                    title: "Ver mais"
                  }, null, 8, ["to"])
                ]),
                _createElementVNode("span", _hoisted_3, [
                  (data.row.active)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        plain: "",
                        loading: data.row.loading,
                        onClick: ($event: any) => (remove(data)),
                        type: "warning",
                        icon: "RemoveFilled",
                        title: "Desativa"
                      }, null, 8, ["loading", "onClick"]))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        plain: "",
                        loading: data.row.loading,
                        onClick: ($event: any) => (remove(data)),
                        type: "success",
                        icon: "Select",
                        title: "Activar"
                      }, null, 8, ["loading", "onClick"]))
                ]),
                (!data.row.featured)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createVNode(_component_el_button, {
                        loading: data.row.loading,
                        onClick: () => featured(data.row),
                        type: "success",
                        title: "Destacar",
                        icon: "Upload"
                      }, null, 8, ["loading", "onClick"])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _createVNode(_component_el_button, {
                        loading: data.row.loading,
                        onClick: () => featured(data.row),
                        type: "warning",
                        title: "Despromover",
                        icon: "Download"
                      }, null, 8, ["loading", "onClick"])
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "data"])
      ]),
      _: 1
    })
  ]))
}
}

})